import {DatePicker, Switch} from 'antd';
import {Rule} from 'antd/lib/form';
import dayjs from 'dayjs';

import {Text} from '../../../../../../../../component/text/text';
import {useLocale} from '../../../../../../../../provider/locale/locale-hook';
import {screenMinWidth} from '../../../../../../../../provider/system/system-context-const';
import {ScreenWidthNameEnum} from '../../../../../../../../provider/system/system-context-type';
import {useSystem} from '../../../../../../../../provider/system/system-hook';
import {CompanyKeyEnum} from '../../../../../../../../service/company-v2/company-const';
import {CompanyFormType, CompanyGeneralErrorType} from '../../../../../../../../service/company-v2/company-type';
import {Form} from '../../../../../../../../typings/antd';
import {disablePastOpeningDates, OPENING_DATE_FORMAT, toOpeningDateDayjs} from '../opening-soon-form-item-helper';

import * as styles from './opening-soon-control.scss';

function getOpeningDateValueProps(value: string | null | undefined): {value: dayjs.Dayjs | null} {
    return {value: toOpeningDateDayjs(value)};
}

function getOpeningDateFromEvent(date: dayjs.Dayjs | null): string | null {
    return date ? date.format(OPENING_DATE_FORMAT) : null;
}

type PropsType = {
    errorMessage?: CompanyGeneralErrorType;
    isSwitchOn: boolean;
    onSwitchChange: (checked: boolean) => void;
    openingDateRules: Array<Rule>;
    showCatalogHint?: boolean;
};

export function OpeningSoonControl(props: PropsType): JSX.Element {
    const {errorMessage, isSwitchOn, onSwitchChange, openingDateRules, showCatalogHint = false} = props;

    const {getLocalizedString} = useLocale();
    const {screen} = useSystem();
    const isCompactLayout = screen.width <= screenMinWidth[ScreenWidthNameEnum.tablet];

    return (
        <div className={styles.OpeningSoonControl}>
            <div className={styles.OpeningSoonControl_switchRow}>
                <div className={styles.OpeningSoonControl_labelGroup}>
                    <Text
                        block
                        className={styles.OpeningSoonControl_labelText}
                        lighter
                        stringKey="COMPANY_FORM__WORKING_TIME__OPENING_SOON"
                    />
                    <Switch checked={isSwitchOn} onChange={onSwitchChange} size="small" />
                </div>

                {isSwitchOn ? (
                    <div className={styles.OpeningSoonControl_dateRow}>
                        <div className={styles.OpeningSoonControl_dateField}>
                            <span className={styles.OpeningSoonControl_dateLabel}>
                                <Text lighter stringKey="COMPANY_FORM__WORKING_TIME__OPENING_SOON__DATE_PLACEHOLDER" />{' '}
                                <span className={styles.OpeningSoonControl_requiredLabel}>*</span>
                            </span>
                            <div className={styles.OpeningSoonControl_pickerRow}>
                                <div className={styles.OpeningSoonControl_datePickerColumn}>
                                    <Form.Item<CompanyFormType>
                                        className={styles.OpeningSoonControl_dateFormItem}
                                        extra={
                                            showCatalogHint && isCompactLayout ? (
                                                <Text
                                                    className={styles.OpeningSoonControl_hintCaption}
                                                    stringKey="COMPANY_FORM__WORKING_TIME__OPENING_SOON__HINT"
                                                />
                                            ) : undefined // eslint-disable-line no-undefined
                                        }
                                        getValueFromEvent={getOpeningDateFromEvent}
                                        getValueProps={getOpeningDateValueProps}
                                        name={CompanyKeyEnum.OpeningDate}
                                        preserve
                                        rules={openingDateRules}
                                    >
                                        <DatePicker
                                            allowClear
                                            className={styles.OpeningSoonControl_datePicker}
                                            disabledDate={disablePastOpeningDates}
                                            format={OPENING_DATE_FORMAT}
                                            placeholder={getLocalizedString(
                                                'COMPANY_FORM__WORKING_TIME__OPENING_SOON__DATE_PLACEHOLDER'
                                            )}
                                            status={errorMessage ? 'error' : undefined} // eslint-disable-line no-undefined
                                        />
                                    </Form.Item>
                                </div>
                                {showCatalogHint && !isCompactLayout ? (
                                    <Text
                                        className={styles.OpeningSoonControl_hintAside}
                                        stringKey="COMPANY_FORM__WORKING_TIME__OPENING_SOON__HINT"
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    );
}
